import { getBackVersion } from '../../config';
import { DepositIntentSnapshot } from '../../models/Banking';
import api from '../api';

const getDepositIntent = (): Promise<DepositIntentSnapshot> =>
    api.request<DepositIntentSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/banking/deposit_intent`,
    });

const createDepositIntent = (amount: number): Promise<DepositIntentSnapshot> =>
    api.request<DepositIntentSnapshot>({
        action: 'BANKING_DEPOSIT',
        method: 'POST',
        url: `${getBackVersion()}/banking/deposit_intent`,
        data: { amount },
    });

export { getDepositIntent, createDepositIntent };
